<template>
  <div class="modal-overlay">
    <div
      style="
        max-width: 97vw;
        position: relative;
        padding-top: 1em;
        padding-bottom: 1em;
      "
      v-if="dialog_loading"
      class="mmodal-content"
    >
      <!--  -->

      <button
        style="
          position: absolute;
          top: 10px;
          right: 10px;
          background-color: red;
          color: white;
          border: none;
          padding: 5px 10px;
          cursor: pointer;
        "
        type="button"
        @click="closeModal"
      >
        <span style="font-size: 1.3em">X</span>
      </button>
      <h3 style="text-align: center">Loading...</h3>

      <!--  -->
    </div>
    <div v-if="!dialog_loading" class="mmodal-content" style="max-width: 40vw">
      <div class="modal-header">
        <h5 class="modal-title">{{ title }}</h5>
        <button type="button" class="close" @click="closeModal">&times;</button>
      </div>
      <div class="modal-body">
        <div class="profile-header">
          <div>
            <h6>{{ message }}</h6>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" @click="saveModal">
          Accept
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "../../../api/apiIndex";
export default {
  name: "Messagedialogue",
  data() {
    return {
      dialog_loading: false,
    };
  },
  props: {
    pres_detail_id: {
      type: [String, Number],
      required: false,
    },
    message: {
      type: [String, Number],
      required: false,
    },
    title: {
      type: [String, Number],
      required: false,
    },
  },
  methods: {
    closeModal() {
      this.$emit("close-message-dialogue");
    },
    async saveModal() {
      this.dialog_loading = true;
      const url = "delete_prescription";
      const body = {
        pres_details_id: this.pres_detail_id,
      };

      const res = await generalApiRequest(url, "POST", body, 1);
      if (res) {
        this.dialog_loading = false;
        this.closeModal();
      }
    },
  },

  mounted() {
    console.log(this.patient_id);
  },
};
</script>

<style scoped>
.modal-body {
  padding: 1rem;
  overflow-y: auto; /* Scrollable content */
  flex-grow: 1; /* Allow the body to grow and take available space */
}

.modal-footer {
  border-top: 1px solid #ddd;
  display: flex;
  justify-content: flex-end;
}

.patient-profile {
  margin: 0;
}

.close {
  background: rgb(233, 22, 22);
  border: 1px solid rgb(182, 178, 178);
  font-size: 1.5rem;
  color: white;
  line-height: 1;
  cursor: pointer;
}

/*  */
</style>
